module.exports = __webpack_public_path__ + "img/driver.fd81ab56.jpg";